import { CheckCircle2, Tv2 } from 'lucide-react';
export default function LiveQrSuccessPage() {
  return (
    <div className="min-h-screen bg-slate-900 text-white flex items-center justify-center p-6">
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-8 max-w-md text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-emerald-500/20 border border-emerald-500/40 rounded-full mb-4">
          <CheckCircle2 className="w-8 h-8 text-emerald-400" />
        </div>
        <h1 className="text-xl font-bold mb-1">TV authorised</h1>
        <p className="text-slate-300 text-sm flex items-center justify-center gap-2 mt-3">
          <Tv2 className="w-4 h-4" /> Return to your TV — your stream will start automatically.
        </p>
      </div>
    </div>
  );
}
